module.exports = __webpack_public_path__ + "img/Sign Stamp.833ebca5.png";